import { createStore } from 'vuex'
import { login } from '../services/auth/auth.api'
import jwt from 'jsonwebtoken'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('smtt_central_auth_user_data')) || {},
    loggedIn: localStorage.getItem('smtt_central_auth_logged_status') === 'true' || false,
    authToken: localStorage.getItem('smtt_central_auth_token') || null,
    mobileDisplay: null,
    mainScreenDropdown: null
  },
  mutations: {
    setUserData(state, userData) {
      state.user = userData
    },
    setAuthToken(state, token) {
      state.authToken = token
    },
    setLoggedStatus(state, status) {
      state.loggedIn = status
    },
    setMobileDisplay(state, payload) {
      state.mobileDisplay = payload
    },
    setMainScreenDropdown(state, payload) {
      state.mainScreenDropdown = payload
    }
  },
  actions: {
    async loginMethod({ commit }, credentials) {
      const {data} = await login(credentials)

        const { auth_token, ...rest } = data;
        jwt.verify(
          auth_token, 
          process.env.VUE_APP_SECRET_OR_PRIVATE_KEY || "tokenTest",
          (error) => {
            if (error) throw new Error('Invalid Credentials');
          }
        )
        
        // set user data
        commit('setUserData', rest)
        localStorage.setItem('smtt_central_auth_user_data', JSON.stringify(rest))
  
        // set auth token
        commit('setAuthToken', auth_token)
        localStorage.setItem('smtt_central_auth_token', auth_token)
        
        // set logged status
        commit('setLoggedStatus', true)
        localStorage.setItem('smtt_central_auth_logged_status', true)

        return true

    },
    logout({ commit }) {
      commit('setUserData', {})
      commit('setLoggedStatus', false)
      commit('setAuthToken', null)
      localStorage.removeItem('smtt_central_auth_user_data')
      localStorage.removeItem('smtt_central_auth_token') 
      localStorage.removeItem('smtt_central_auth_logged_status')
    }
  },
  modules: {
  }
})
